import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "标签名称"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "类型"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "type", $$v);
      },
      expression: "searchForm.type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "主标签",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "自定义",
      value: 0
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          page: 1,
          limit: 20,
          name: "",
          type: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.form = {
          name: "",
          type: 1,
          custom_views: 0
        };
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v("新增 ")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "is_system_tag",
      label: "标签类型",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var type = _ref.row.type;
        return [_c("el-tag", {
          attrs: {
            size: "small",
            type: type === 1 ? "-" : "info"
          }
        }, [_vm._v(_vm._s(type === 1 ? "主标签" : "自定义") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "total_views",
      label: "总浏览量",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "custom_views",
      label: "追加浏览量",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "release_count",
      label: "发布量",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "release_month_1",
      label: "近1月发布量",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("修 改 ")]), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删 除 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.limit,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.$route.meta.title, "\u7F16\u8F91"),
      width: "400px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      },
      close: _vm.close
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "标签名称",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      maxlength: 20
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "追加浏览量"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.custom_views,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "custom_views", $$v);
      },
      expression: "form.custom_views"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "标签类型"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1,
      border: "",
      size: "mini"
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v(" 主标签 ")]), _c("el-radio", {
    attrs: {
      label: 0,
      border: "",
      size: "mini"
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v(" 自定义标签 ")])], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };